export const i18n = {
    rte: {
        linkModal: {
            modalHeader: "Insert link",
            inputUrl: "URL",
            validationInputUrl: "URL is invalid",
            inputDisplayText: "Text to display",
            validationInputDisplayText: "The field is mandatory",
            buttonRemove: "Remove",
            buttonCancel: "Cancel",
            buttonOk: "Ok",
        },
        imageModal: {
            modalHeader: "Insert Image",
            inputSource: "Source",
            validationInputSource: "Source is invalid",
            inputImageDescr: "Image description",
            buttonCancel: "Cancel",
            buttonOk: "Ok",
        },
    },
};
